import { FC, ReactNode, useState } from 'react';
import Button from 'shared/components/andtComponents/Button.tsx';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';

import styles from './InfoBanner.module.scss';

interface InfoBannerProps {
  title?: string;
  text: ReactNode;
  icon?: string;
  closable?: boolean;
  onClose?: () => void;
  className?: string;
  automationId?: string;
}

const InfoBanner: FC<InfoBannerProps> = ({
  title,
  text,
  icon = ICONS.lightbulb.name,
  closable = true,
  onClose,
  className = '',
  automationId,
}) => {
  const [isBannerVisible, setIsBannerVisible] = useState(true);

  const handleClose = () => {
    setIsBannerVisible(false);
    onClose?.();
  };

  return isBannerVisible ? (
    <div className={`${styles.banner} ${className}`}>
      <div className={styles.bannerLeft}>
        <GenerateIcon iconName={icon} className={styles.icon} />
        {title ? <div className={styles.bannerTitle}>{title}</div> : null}
        <div className={styles.bannerText}>{text}</div>
      </div>
      {closable && (
        <div className={styles.bannerRight}>
          <Button
            className={{ button: styles.closeButton }}
            isTextButton
            onClick={handleClose}
            icon={() => <GenerateIcon iconName={ICONS.xMark.name} />}
            automationid={automationId}
          />
        </div>
      )}
    </div>
  ) : null;
};

export default InfoBanner;
